<!-- 空状态-吴影茹 -->
<template>
  <div class="column_center_center">
    <img src="@/assets/images/common/empty-ghost.png" v-if="ghost" :style="{ width: size + 'px', height: size + 'px' }" />
    <img src="@/assets/images/common/empty.png" v-else :style="{ width: size + 'px', height: size + 'px' }" />
    <div :style="{ color: ghost ? 'white' : '#909399', fontSize: (size / 200) * 14 + 'px', marginTop: ghost ? '10px' : '' }">{{ description }}</div>
  </div>
</template>
              
<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'

const props = defineProps({
  // 描述文本
  description: {
    type: String,
    default: '暂无数据'
  },
  ghost: {
    type: Boolean,
    default: false
  },
  //   图片大小
  size: {
    type: Number,
    default: 200
  }
})

onMounted(() => {})
</script>
              
<style lang="scss" scoped>
</style>